import { useQuery } from 'react-query';
import { getAttributes } from 'modules/api';

export const useGetAttributes = (onSuccess) => {
  return useQuery(['getAttributes'], getAttributes, {
    onSuccess,
  });
};
